import React from 'react';
import './Events.css';
import { EventItem } from '../../components/ContentItems';
import HeroCarousel from '../../components/HeroCarousel';
import { useContent } from '../../context/ContentContext';

const Events = () => {
  const { events, siteContent } = useContent();
  const sortedEvents = [...events].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <>
      <HeroCarousel page="Events" />
      <div className="publications">
        <h2>
          <span dangerouslySetInnerHTML={{ __html: siteContent.events_intro_html }} />
        </h2>
        <h2>
          {siteContent.events_past_heading}
        </h2>
        {/* {loading && <p className="content-loading">Loading events...</p>} */}
        {sortedEvents.map((event) => (
          <EventItem
            key={event.id || `event-${event.sortOrder}-${event.title || event.plainText}`}
            event={event}
          />
        ))}
      </div>
    </>
  );
};

export default Events;
